import * as MUI from '@mui/material'
import { Stack } from 'ui/baseComponents'
import { SECTION_TITLES } from 'ui/clinicianScreens/Patient/Report/consts'

const STYLES = {
  toggles: {
    '@media print': {
      display: 'none',
    },
  },
}

const ReportSectionsToggle = ({
  hasDataSet,
  hiddenSections,
  isClinicianReport,
  setHiddenSections,
}) => {
  const {
    HIGHLIGHTS,
    SUPPORTING_MATERIALS,
    SUPPORTING_MATERIALS_RED_FLAGS_AND_OTHER_REPORTED_ISSUES,
    TOP_CONCERNS,
    ...sectionTitles
  } = SECTION_TITLES

  const titlesToShow = sectionTitles

  const {
    EMERGENCY_DEPT_VISIT,
    RED_FLAGS,
    OTHER_ISSUES,
    DYSKINESIA_MANAGEMENT,
  } = titlesToShow

  const hideSection = (key) => {
    setHiddenSections((prev) => new Set(prev.add(key)))
  }

  const showSection = (key) => {
    setHiddenSections((prev) => {
      const next = new Set(prev)
      next.delete(key)
      return next
    })
  }

  const toggleLabels = isClinicianReport
    ? Object.values(titlesToShow)
    : Object.values(titlesToShow).filter(
        (title) =>
          title !== RED_FLAGS &&
          title !== OTHER_ISSUES &&
          title !== DYSKINESIA_MANAGEMENT,
      )
  return (
    <Stack
      sx={STYLES.toggles}
      direction="row"
      alignItems="center"
      spacing={4}
      flexWrap="wrap"
    >
      <MUI.FormLabel component="legend">Show sections:</MUI.FormLabel>
      <MUI.FormGroup row>
        {toggleLabels.map((label) => (
          <MUI.FormControlLabel
            control={
              <MUI.Checkbox
                disabled={
                  (isClinicianReport &&
                    ![RED_FLAGS, OTHER_ISSUES, DYSKINESIA_MANAGEMENT].includes(
                      label,
                    ) &&
                    !hasDataSet.has(label)) ||
                  (!isClinicianReport &&
                    label === EMERGENCY_DEPT_VISIT &&
                    !hasDataSet.has(label))
                }
                checked={!hiddenSections.has(label)}
                onChange={(e) => {
                  if (e.target.checked) {
                    showSection(label)
                  } else {
                    hideSection(label)
                  }
                }}
              />
            }
            label={label}
            key={label}
            data-cy={`toggle-${label}`}
          />
        ))}
      </MUI.FormGroup>
    </Stack>
  )
}

export default ReportSectionsToggle
